import PropTypes from 'prop-types';
import UdcCard from 'uI/UdcCard/UdcCard';

import { Degrees } from 'constants/degreesDiscover';
import { Posgraduates } from 'constants/posgraduatesDiscover';
import classes from './Udc.module.css';

const Udc = props => {
  return (
    <div className={classes.storeContainer}>
      <p className={classes.section}>
        {props.degrees ? 'Licenciaturas' : 'Posgrados'}
      </p>
      {props.degrees
        ? Degrees.map(item => (
            <UdcCard
              key={item.link}
              itemData={item}
              section="degree"
            />
          ))
        : Posgraduates.map(item => (
            <UdcCard
              key={item.link}
              itemData={item}
              section="posgrado"
            />
          ))}
    </div>
  );
};

Udc.propTypes = {
  // eslint-disable-next-line react/require-default-props
  degrees: PropTypes.bool
};

export default Udc;
